import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, connect } from "react-redux";
import AOS from "aos";
import "aos/dist/aos.css";

//Ant design imports
import { Button, Form, Input, Card, Row, Typography, Col } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";

//Project Imports
import { SignOutAction } from "../../redux/actions/authAction";
import appLabel from "../../config/appLabel";
import cnt from "../../services/definedConstant";
import api from "../../services/definedApi";
import { BOM } from "../../services/definedMethod";
import Bg from "../../assets/images/avatars/dash-bg-4.png";
import Avatar from "../../assets/images/avatars/avatar-teal.svg";
// import FinsysLogo from "../../assets/images/finsys_771.png";
import FinsysLogo from "../../assets/images/Logo-Montran2.png";
import appConfig from "../../config/appConfig";
import proModuleLicensingConfig from "../../services/moduleLicensingProd.json";
import devModuleLicensingConfig from "../../services/moduleLicensingDev.json";

import {
  buildAndEncryptLoginToken,
  decryptLoginToken,
  decryptToken,
  encryptPayload,
  parseDecryptedValue,
} from "./EncryptAuth";

const { Text, Title } = Typography;

const SignIn = (props) => {
  const { SignOutAction } = props;

  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const moduleLicensingConfig = appConfig.isProduction
    ? proModuleLicensingConfig
    : devModuleLicensingConfig;

  useEffect(() => {
    console.log("hello OTG");

    appConfig.apiSettings.headers["Authorization"] =
      process.env.REACT_APP_HEADER_AUTHORIZATION;

    SignOutAction();
    AOS.init({ duration: 3000 });
  }, []);

  const handleFormSubmit = (formValues) => {
    setIsLoading(true);
    const encryptedBody = encryptPayload(formValues.password);

    const body = {
      username: formValues.username,
      password: encryptedBody,
    };

    BOM.SessionLessReqAction(
      body,
      api.Authentication,
      async (err, res) => {
        if (err) {
          const backendMessage =
            err?.errors?.[0]?.defaultUserMessage ||
            err?.defaultUserMessage ||
            err?.developerMessage ||
            "";

          // const isInvalidCredentials =
          //   backendMessage?.toLowerCase().includes("unauthenticated") ||
          //   backendMessage?.toLowerCase().includes("invalid authentication") ||
          //   backendMessage?.toLowerCase().includes("invalid") ||
          //   err?.httpStatusCode === "401";

          // const errorMessage = isInvalidCredentials
          //   ? "Invalid Username or Password"
          //   : backendMessage || "An error occurred during authentication";
          console.log(backendMessage, "backendMessage");
          const isInvalidCredentials = backendMessage
            ?.toLowerCase()
            .includes("unauthenticated. please login.");

          console.log(isInvalidCredentials, "isInvalidCredentials");
          const errorMessage = isInvalidCredentials
            ? "Invalid Username or Password"
            : backendMessage || "An error occurred during authentication";

          BOM.AlertMsg(cnt.DANGER, errorMessage);
          setIsLoading(false);
        } else {
          BOM.InitializeModuleLicensing(moduleLicensingConfig);
          // console.log(moduleLicensingConfig);
          const decrypted = decryptLoginToken(
            res?.base64EncodedAuthenticationKey,
          );

          const temp = {
            session: "Basic " + res?.base64EncodedAuthenticationKey,
            ...res,
            licensingConfig: moduleLicensingConfig,
            isTwoFactorAuthenticationRequired:
              decrypted.isTwoFactorAuthenticationRequired,
            shouldRenewPassword: decrypted.shouldRenewPassword,
          };

          console.log(temp);

          if (!decrypted) {
            BOM.AlertMsg(cnt.DANGER, "Error decrypting login token");
            setIsLoading(false);
            return;
          }

          if (
            decrypted.isTwoFactorAuthenticationRequired &&
            decrypted.shouldRenewPassword
          ) {
            navigate("/two-factor-auth", { state: temp });
          } else if (decrypted.isTwoFactorAuthenticationRequired) {
            navigate("/two-factor-auth", { state: temp });
          } else if (decrypted.shouldRenewPassword) {
            navigate("/reset-password", { state: temp });
          }
          // Normal flow - go to dashboard
          else {
            navigate("/dashboard");
            window?.DevtoolsSoftDetector?.start();
          }

          dispatch({
            type: cnt.SIGN_IN,
            payload: temp,
          });
        }
      },
      { includeIP: true },
    );
  };

  return (
    <>
      <img className="auth-bg" src={Bg} />
      <div className="login-container">
        <Card className="login-card">
          <Form
            layout="vertical"
            name="basic"
            initialValues={{ remember: true }}
            onFinish={handleFormSubmit}
            autoComplete="off"
          >
            <Col style={{ width: "100%" }}>
              <Row style={{ marginBottom: 5 }}>
                <Title
                  level={4}
                  style={{
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginBottom: 0,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 5,
                  }}
                  data-aos="flip-left"
                  data-aos-easing="ease-out-cubic"
                >
                  <small>Welcome to</small>{" "}
                  <img
                    src={FinsysLogo}
                    style={{
                      marginTop: 0,
                      padding: 0,
                      width: 100,
                      // height: 10,
                    }}
                  ></img>
                  {/* <span
                    style={{
                      fontFamily: "cursive",
                      fontSize: 24,
                      color: "var(--of-purple)",
                    }}
                  >
                    {"Eclippse".toUpperCase()}
                  </span> */}
                </Title>
                {/* <img src={Logo} alt="" /> */}
                <img
                  src={Avatar}
                  style={{ width: "60px", marginBottom: "20px" }}
                />
              </Row>
              <Row style={{ marginBottom: 20 }}>
                <Text
                  style={{
                    marginLeft: "auto",
                    marginRight: "auto",
                    color: "#9C9C9C",
                    textAlign: "center",
                  }}
                >
                  Sign In to access your dashboard, settings and more.
                </Text>
              </Row>
              <Row style={{ marginBottom: 10 }}>
                <Form.Item
                  style={{ width: "100%", marginBottom: 10 }}
                  name={"username"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(appLabel.username),
                    },
                    {
                      min: true,
                      message: "Minimum username length is 3 characters",
                    },
                  ]}
                >
                  <Input
                    placeholder={`${appLabel.username}`}
                    style={{ padding: 10, borderRadius: 10 }}
                    prefix={<UserOutlined className="site-form-item-icon" />}
                  />
                </Form.Item>
              </Row>
              <Row style={{ marginBottom: 10 }}>
                <Form.Item
                  style={{ width: "100%", marginBottom: "5px" }}
                  name={"password"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(appLabel.password),
                    },
                  ]}
                >
                  <Input.Password
                    placeholder={`${appLabel.password}`}
                    style={{ padding: 10, borderRadius: 10 }}
                    prefix={<LockOutlined className="site-form-item-icon" />}
                  />
                </Form.Item>
              </Row>
              {/* <Row>
              <Link style={{ marginBottom: "10%" }}>Forgot Password?</Link>
            </Row> */}
              <Row>
                <Form.Item style={{ width: "100%", marginTop: "10%" }}>
                  {" "}
                  <Button
                    className="of-authBtnColor"
                    size="large"
                    type="primary"
                    htmlType="submit"
                    loading={isLoading}
                  >
                    {
                      <Text style={{ color: "black" }}>
                        {"Sign in".toUpperCase()}
                      </Text>
                    }
                  </Button>
                </Form.Item>
              </Row>
              <Row>
                <Col span={24}>
                  <Footer />
                </Col>
              </Row>
            </Col>
          </Form>
        </Card>
      </div>
    </>
  );
};

const mapDispatchToProps = { SignOutAction };
export default connect(null, mapDispatchToProps)(SignIn);

const Footer = () => {
  return (
    <div
      style={{
        textAlign: "center",
        marginTop: 24,
        color: "#9C9C9C",
        fontSize: 12,
      }}
    >
      <img
        src={FinsysLogo}
        alt="Montran"
        style={{ width: 70, marginBottom: 6, opacity: 0.7 }}
      />
      <div>© {new Date().getFullYear()} Montran Corporation. All rights reserved.</div>
    </div>
  );
};
